import { BorrowerLendingLimitTableType } from '../tables/BorrowerLendingLimitTableType';
import { BorrowerLendingLimitTableDefinition } from '../tables/BorrowerLendingLimitTableDefinition';

export const getCalculationLogic = (table: BorrowerLendingLimitTableType, field: string): string | undefined => {
    const tableDef = BorrowerLendingLimitTableDefinition[table];
    if (!tableDef) return undefined;

    const colDef = tableDef.find((col) => col.field === field);
    return colDef?.calculationLogic;
};
